var MapConfig = /** @class */ (function () {
    function MapConfig() {
        this.linksControl = false;
        this.panControl = false;
        this.enableCloseButton = false;
        this.mapTypeControl = false;
        this.heading = 90;
        this.tilt = 45;
    }
    return MapConfig;
}());
export { MapConfig };
//# sourceMappingURL=map.conf.js.map